import React from 'react';
import { StarIcon } from './icons';
import { Pill } from './Pill';
import { testimonials } from '../data/testimonials';
function initials(author: string): string {
  return author.split(/\s+/).map(part => part.charAt(0).toUpperCase()).join('');
}
export function TestimonialsSection() {
  return <section className="w-full bg-cream py-10 sm:py-12" aria-labelledby="testimonials-heading" data-id="element-200" data-mp="1r142gd6zybqk">
      <div className="mx-auto max-w-6xl px-6" data-id="element-201" data-mp="1d1bh6xe8onpz">
        <div className="text-center" data-id="element-202" data-mp="1d0jk1i4zuhxl">
          <Pill tone="rose" data-id="element-203" data-mp="1i0o2hdpgpmqg">In their words</Pill>
          <h2 id="testimonials-heading" className="mx-auto mt-5 max-w-2xl font-display text-4xl leading-tight text-charcoal sm:text-5xl" data-id="element-204" data-mp="1i2ioywgdtmwn">
            What ballet teachers are already saying
          </h2>
        </div>

        <ul className="mt-10 grid gap-6 md:grid-cols-3" data-id="element-205" data-mp="184ugz4trmiwj">
          {testimonials.map(testimonial => <li key={testimonial.author} className="flex h-full flex-col rounded-3xl border border-rose-deep/20 bg-blush p-7" data-id="element-206" data-mp="2yfz2ademtzzj">
              <div className="flex gap-1" aria-label="Rated 5 out of 5" data-id="element-207" data-mp="2v1kren3ga7v8">
                {Array.from({
              length: 5
            }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-gold text-gold" aria-hidden="true" data-id="element-208" data-mp="2q1gc30ea3j6l" data-mpi={index} />)}
              </div>

              <blockquote className="mt-5 font-display text-xl leading-relaxed text-charcoal/90" data-id="element-209" data-mp="34qugdu2zzaf4">
                “{testimonial.quote}”
              </blockquote>

              <footer className="mt-auto flex items-center gap-3 pt-7" data-id="element-210" data-mp="2c1x365dn83t8">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-rose-light font-sans text-xs font-semibold tracking-wide text-wine" aria-hidden="true" data-id="element-211" data-mp="273n8rwzqt78o">
                  {initials(testimonial.author)}
                </span>
                <span className="font-sans text-sm" data-id="element-212" data-mp="2h0i303ozglh5">
                  <span className="block font-semibold text-charcoal" data-id="element-213" data-mp="1a5lj5cs1p5a">
                    {testimonial.author}
                  </span>
                  <span className="block text-xs text-ash" data-id="element-214" data-mp="3sgghin2xjzpr">
                    {testimonial.role}, {testimonial.location}
                  </span>
                </span>
              </footer>
            </li>)}
        </ul>
      </div>
    </section>;
}